import { popoverAnatomy } from '@chakra-ui/anatomy'
import { defineSlotRecipe } from '@chakra-ui/react'

export const popoverSlotRecipe = defineSlotRecipe({
  className: 'chakra-popover',
  slots: popoverAnatomy.keys,
  base: {},
  variants: {
    variant: {
      extraInformation: {
        body: {
          color: 'white',
          bg: 'brand.blue',
          padding: '1.25rem',
          borderRadius: '3px',
        },
        arrow: {
          bg: 'red.500',
        },
      },
    },
  },
  defaultVariants: {
    variant: 'extraInformation',
  },
})

// import { popoverAnatomy as parts } from '@chakra-ui/anatomy'
// import { createMultiStyleConfigHelpers } from '@chakra-ui/react'
// const helper = createMultiStyleConfigHelpers(parts.keys)
// const extraInformation = helper.definePartsStyle({
//   arrow: {
//     '--popper-arrow-bg': 'var(--chakra-colors-brand-blue)',
//   },
//   content: {
//     color: 'white',
//     bg: 'brand.blue',
//     padding: '1.25rem',
//     borderRadius: '3px',
//   },
// })
// export const popoverTheme = helper.defineMultiStyleConfig({ variants: { extraInformation } })
